import React from 'react';
import cx from 'classnames';

import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';

import shared from '~/styles/landingPageShared.module.less';
import imageSectionCSS from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

const text = (
  <div className={imageSectionCSS.dek}>
    Let guests help with your whole trip from airfare to hotels, snorkeling and more.
  </div>
);
const image = (
  <>
    <div className={cx(css.sectionImage1)}>
      <span role="img" aria-label="image of wedding guests enjoying a wedding reception" />
    </div>
    {renderAsBackgroundImage({
      selector: `.${css.sectionImage1}`,
      backgroundImageName: 'try',
      directory: 'CashGiftsLP/imageSections',
      filetype: ['png', 'png', 'png'],
      notVersioned: true,
    })}
  </>
);

/* ------------------------------------------------------------ */
const TryHoneymoonImageSection: React.FC = () => (
  <ImageSection
    backgroundColor={bgColorOption.lightGray}
    className={shared.borderBottom}
    headerTag="h2"
    textPosition="right"
    title="Try Honeymoon Funds (they’re most popular!)"
    imageContents={image}
    secondaryContents={text}
  />
);

export default TryHoneymoonImageSection;
